export const FMS_ROLES = [
  {
    key: 'FMSManager.Access',
    labelKey: 'roleManager',
    fallback: 'Manager',
  },
  {
    key: 'FMSClient.Access',
    labelKey: 'roleClient',
    fallback: 'Client',
  },
  {
    key: 'FMSContractor.Access',
    labelKey: 'roleContractor',
    fallback: 'Contractor',
  },
  {
    key: 'FMSPortal.AdminAccess',
    labelKey: 'roleAdmin',
    fallback: 'Admin',
  },
] as const;

export type FmsRole = (typeof FMS_ROLES)[number];

const byKey = new Map<string, FmsRole>(
  FMS_ROLES.map((role) => [role.key, role])
);

export const fmsRoleByKey = (key: string): FmsRole | undefined =>
  byKey.get(key);

export const selectableFmsRoles = (roleKeys: readonly string[]): FmsRole[] => {
  const set = new Set(roleKeys);
  return FMS_ROLES.filter((role) => set.has(role.key));
};

export const appPathForRole = (key: string): '/client' | '/contractor' =>
  key === 'FMSContractor.Access' ? '/contractor' : '/client';
